<template>
    <div class="form-main">
        <h2 class="form-main__header-title">
            {{type==='basic-info' ? "基础信息" : "收款信息（支付宝）"}}
        </h2>
        <van-form
            @submit="onSubmit"
            input-align="left"
        >
            <!-- <van-field
                v-if="isBasicInfoType"
                v-model="nickname"
                type="text"
                label="微信昵称"
                name="nickname"
                readonly
            /> -->
            <van-field
                v-if="isBasicInfoType"
                v-model="wechatNo"
                type="text"
                label="微信号"
                name="wechatNo"
                placeholder="请输入微信号"
                :rules="[{ required: true, message: '方便与您联系' }]"
            />
            <van-field
                v-if="isBasicInfoType"
                v-model="phone"
                type="text"
                label="手机号"
                name="phone"
                placeholder="请输入手机号"
                :rules="[{ required: true, message: '方便与您联系', pattern: /^1[3456789]\d{9}$/ }]"
            />

            <van-field
                v-if="!isBasicInfoType"
                v-model="alipayAccount"
                type="text"
                label="支付宝账号"
                name="alipayAccount"
                placeholder="请输入支付宝账号"
                :rules="[{ required: true, message: '提现时目标账户'}]"
            />
            <van-field
                v-if="!isBasicInfoType"
                v-model="alipayRealName"
                type="text"
                label="认证人名"
                name="alipayRealName"
                placeholder="请输入支付宝实名名称"
                :rules="[{ required: true, message: '提现时用于验证'}]"
            />
            <div style="margin: 16px;">
                <van-button
                    :loading="loading"
                    loading-text="提交中..."
                    round
                    block
                    type="primary" 
                    native-type="submit"
                    color="linear-gradient(to right, #ff6034, #ee0a24)"
                >
                    提交
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import {Field, Form, Button} from 'vant';
import request from '@/utils/request.js';
export default {
    name: 'AllForm',
    components: {
        [Field.name]: Field,
        [Form.name]: Form,
        [Button.name]: Button
    },
    props: {
        // alipay, basic-info
    },
    data() {
        return {
            loading: false,
            nickname: "",
            phone: "",
            wechatNo: "",
            alipayAccount: "",
            alipayRealName: "",
            type: "basic-info"
        };
    },
    computed: {
        isBasicInfoType: function() {
            return this.type === 'basic-info';
        }
    },
    mounted() {
        this.nickname = this.$route.query.nickname ? this.$route.query.nickname : "";
        this.type = this.$route.query.type;
        this.phone = this.$route.query.phone ? this.$route.query.phone : '';
        this.alipayAccount = this.$route.query.alipayAccount ? this.$route.query.alipayAccount : "";
        this.alipayRealName = this.$route.query.alipayRealName ? this.$route.query.alipayRealName : "";
        this.wechatNo = this.$route.query.wechatNo ? this.$route.query.wechatNo : "";
    },
    methods: {
        async onSubmit(values) {
            this.loading = true;

            const url = this.isBasicInfoType ? '/user/updateWechatBasicInfo' : '/user/updateAlipayInfo' ;
            const {response} = await request.post(url, {
                data: values
            });

            if (response.ok) {
                this.$notify({type: 'success', message: '提交成功'});
            }

            this.loading = false;
        }
    }
}
</script>

<style lang="less">
@import "@/style/base.less";
.form-main {
    color: @font-color-normal;
    font-size: @font-size-normal;
    font-weight: @font-weight-normal;
}
.form-main__header-title {
    margin: 0;
    font-size: @font-size-title;
    color: @font-color-title;
    font-weight: @font-weight-title;
    padding: 20px 16px 16px;
}
</style>